export default __webpack_public_path__ + "static/media/Ballroll_00118.0c2a4951.png";